import React from 'react'

import { NavLabelItemRoot } from './NavIem.style'

const NavLabelItem = ({ item, ...other }) => {
  return <NavLabelItemRoot {...other}>{item.label}</NavLabelItemRoot>
}

export default NavLabelItem
